import { render, staticRenderFns } from "./brand_campaigns.vue?vue&type=template&id=5f730a84"
import script from "./brand_campaigns.vue?vue&type=script&lang=js"
export * from "./brand_campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports